<template>
  <router-link class="latest" v-if="post" :to="post.link">
    <h1 v-text="post.title.rendered"></h1>
    <div class="latest_excerpt" v-html="post.excerpt.rendered"></div>
    <BetButton :link="false" text="Ver Mais" class="btn"/>
    <img :src="post.images.large" alt="" srcset="">
  </router-link>
</template>

<script>
  import BetButton from '@/components/BetButton.vue';

  export default {
    name: 'LatestMag',
    components: {
      BetButton,
    },
    props: {
    },
    computed: {
      post() {
        return this.$store.getters['betanomag/last']
      },
    },
    mounted() {
      this.$store.dispatch("betanomag/getAll")
    },
  }
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors";
@import "@/assets/scss/queries";
@import "@/assets/scss/fonts";

.latest {
  --latest-mag-excerpt-size: .75rem;
  --latest-mag-excerpt-width: var(--content-width);
  --latest-mag-image-margin: 0 0 0 auto;
  --latest-mag-image-width: var(--content-width);
  --latest-mag-title-size: 1.75rem;
  --latest-mag-title-width: var(--content-width);

  @include media(sm) {
    --latest-mag-excerpt-size: 1rem;
    --latest-mag-excerpt-width: calc(100% * 1 / 3);
    --latest-mag-image-margin: -8rem 0 0 auto;
    --latest-mag-image-width: calc(100vw * 2 / 3);
    --latest-mag-title-size: 3rem;
    --latest-mag-title-width: calc(100% * 2 / 3);
  }

  text-decoration: none;
  text-transform: uppercase;
  display: grid;
  flex-direction: column;
  width: 100%;
  position: relative;
  //padding: 0 0 0 var(--side-padding);
  padding: 0 var(--side-padding);

  grid-template-areas:
      "title img"
      "text img"
      "btn img"
  ;
  grid-template-columns: 3fr 1.25fr;
  grid-template-rows: min-content min-content 1fr;
  gap: calc(.015 * var(--content-width));

  h1 {
    color: $color-white;
    font-weight: 900;
    font-size: var(--latest-mag-title-size);
    // width: var(--latest-mag-title-width);
    grid-area: title;
    margin: 0;
  }

  img {
    // margin: var(--latest-mag-image-margin);
    // width: var(--latest-mag-image-width);
    width: 100%;
    pointer-events: none;
    grid-area: img;
  }

  &_excerpt {
    color: $color-white;
    // max-width: var(--latest-mag-excerpt-width);
    line-height: 1.5;
    font-size: var(--latest-mag-excerpt-size);
  }

  .btn {
      height: fit-content;
  }
}
</style>
